// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({2239: "ActionToast",2733: "NftSecondaryMarketModal",2944: "RecentlyViewed",5338: "NftPdpZoomModal",8756: "EthereumWallet",9289: "ModelViewer",}[chunkId] || chunkId) + ".567.0.0." + {2239: "1c90c7ff900e2937",2733: "d561fdfbaf15c2c7",2944: "125c2ff85c1d3895",5233: "97f8e895d33cb4ea",5338: "493fc5c7613372e3",8756: "730acd9b1ff34456",9289: "4f6c4132f3ffd2f1",}[chunkId] + ".css"
}